module.exports = __webpack_public_path__ + "static/media/haltian-logo.5c2d87aa.svg";